.container {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
  padding: 4px;
}

.container .rating-btn {
  background-color: rgba(143, 153, 168, 0.15);
  border-radius: 4px;
  padding: 6px;
}

.container .rating-btn:hover {
  color: rgba(143, 153, 168, 0.9);
}

.container .rating-btn:focus,
.container .rating-btn:active {
  outline: none;
  box-shadow: none;
}

.container .rating-btn--liked {
  color: rgb(50, 164, 103);
}

.container .rating-btn--disliked {
  color: rgb(231, 106, 110);
}

.container .thumbs-icon {
  font-size: 18px;
}

.circular-icon {
  margin-left: 10px;
}

@media print {
  .container {
    display: none !important;
  }
}
